
export const audienceTranslations = {
  forWhomTitle: {
    fr: "À qui s'adresse First Tuesday",
    en: "Who First Tuesday is for"
  },
  entrepreneurs: {
    fr: "Entrepreneurs confirmés",
    en: "Proven entrepreneurs"
  },
  entrepreneursDesc: {
    fr: "Fondateurs et dirigeants d'entreprises avec un track record éprouvé en Algérie et dans la diaspora",
    en: "Founders and business leaders with proven track record in Algeria and the diaspora"
  },
  techLeaders: {
    fr: "CTO / Tech leads / Builders",
    en: "CTO / Tech leads / Builders"
  },
  techLeadersDesc: {
    fr: "Leaders techniques expérimentés et développeurs avec expertise reconnue",
    en: "Experienced technical leaders and developers with recognized expertise"
  },
  investors: {
    fr: "Investisseurs",
    en: "Investors"
  },
  investorsDesc: {
    fr: "Investisseurs actifs et expérimentés focalisés sur l'écosystème algérien et MENA",
    en: "Active and experienced investors focused on the Algerian and MENA ecosystem"
  },
  experts: {
    fr: "Experts",
    en: "Experts"
  },
  expertsDesc: {
    fr: "Experts reconnus en tech, stratégie et développement économique avec expertise avérée",
    en: "Recognized experts in tech, strategy and economic development with proven expertise"
  },
  communityLeaders: {
    fr: "Leaders communautaires",
    en: "Community leaders"
  },
  communityLeadersDesc: {
    fr: "Leaders d'opinion bienveillants et catalyseurs du changement avec impact concret en Algérie",
    en: "Benevolent opinion leaders and change catalysts with concrete impact in Algeria"
  },
  joinClub: {
    fr: "Rejoindre le club",
    en: "Join the club"
  },
  ecosystemDesc: {
    fr: "Un réseau de leaders expérimentés connectant l'Algérie à sa diaspora mondiale",
    en: "A network of experienced leaders connecting Algeria to its global diaspora"
  }
};
